module.exports = __webpack_public_path__ + "img/banzu@2x.64304464.png";